import {
	registerDecorator,
	ValidationArguments,
	ValidationOptions,
	ValidatorConstraint,
	ValidatorConstraintInterface
} from "class-validator";
import { isNumber } from 'lodash-es';

@ValidatorConstraint({ name: 'IsHigherThan' })
export class IsHigherThanValidator implements ValidatorConstraintInterface {
	validate(value: any, args: ValidationArguments) {
		const relatedField = args.constraints[0] as string;
		const relatedValue = (args.object as Record<string, any>)[relatedField];

		return isNumber(value) && isNumber(relatedValue) && value > relatedValue;
	}

	defaultMessage(args: ValidationArguments) {
		return `${args.property} cannot be lower than or equal to ${args.constraints[0]}.`;
	}
}

export const IsHigherThan = (
	relatedField: string,
	validationOptions?: ValidationOptions
) => (object: Record<never, never>, propertyName: string) => {
	registerDecorator({
		name: 'IsHigherThan',
		target: object.constructor,
		propertyName,
		constraints: [relatedField],
		options: validationOptions,
		validator: IsHigherThanValidator,
	});
};
